import {
    FormControlLabel,
    Checkbox,
    FormControl, MenuItem, InputLabel, Select,
    Paper,
    Table,
    Grid,
    TextField,
    InputAdornment,
    ListItemText,
} from '@mui/material';

import { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { AllCommunityModule, ModuleRegistry, DateFilterModule, } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { toast, ToastContainer } from 'react-toastify';
import axiosInstance from '../../../../lib/axios';
import { Box, Typography, CircularProgress, Tooltip, IconButton, Button } from '@mui/material';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { useSelector } from 'react-redux';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useNavigate, useLocation } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import '../../../../AgGridStyle.css';
import HomeIcon from '@mui/icons-material/Home';

import { getYojnaMasterdropdata, getShiftMasterdropdata, getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';

ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule,]);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const Weektaskreport = () => {
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const UserId = sessionStorage?.getItem('UserId');
    const permissions = usePermissions("Promocode Master");
    const [yojna, setYojna] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [propertyData, setPropertyData] = useState([]);
    const [AddRec, setAddRec] = useState("0");
    const [selectedYojnas, setSelectedYojnas] = useState([]);
    const gridRef = useRef();
    const navigate = useNavigate();
    const globalProperty = useSelector(selectGlobalProperty);  
    const location = useLocation()

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };


    const getMaxDate = () => {
        const maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 30);
        const year = maxDate.getFullYear();
        const month = String(maxDate.getMonth() + 1).padStart(2, '0');
        const day = String(maxDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        if (location.state && location.state.rowData) {
            console.log('Received data from summary report:', location.state);
            setFormData({
                Property: location.state.propertyId || '',
                Shift: location.state.shiftId || '',
                Yojna: '',
                FromDate: location.state.fromDate || todayDate,
                ToDate: location.state.toDate || todayDate,
            });

            if (location.state.selectedYojnas) {
                setSelectedYojnas(location.state.selectedYojnas);
            }

            if (location.state.rowData) {
                fetchReportData(location.state.rowData);
            }
        } else {
            console.log('No data received from navigation');
        }
    }, [location.state]);

    const todayDate = getTodayDate();
    const maxDate = getMaxDate();

    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        Yojna: '',
        FromDate: todayDate,
        ToDate: todayDate,
    });


    const colDefs = useMemo(() => [
        { field: 'RowNum', headerName: 'Sr.No', width: 60 },
        { field: 'YojanaName', headerName: 'Yojana', width: 150 },
        { field: 'HkWrkAreaName', headerName: 'Work Area', width: 120 },
        { field: 'HkTaskName', headerName: 'Task', width: 180 },
        {
            field: 'WrkRecvDt',
            headerName: 'Received Date',
            width: 130,
            valueFormatter: (params) => {
                if (!params.value) return '';
                const date = new Date(params.value);
                return date.toLocaleDateString('en-IN');
            }
        },

        {
            field: 'Sun',
            headerName: 'Sun',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'SunA',
            headerName: 'Sun (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Mon',
            headerName: 'Mon',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'MonA',
            headerName: 'Mon (A)',
            width: 90,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Tue',
            headerName: 'Tue',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },


        {
            field: 'TueA',
            headerName: 'Tue (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Wed',
            headerName: 'Wed',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },

        {
            field: 'WedA',
            headerName: 'Wed (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Thu',
            headerName: 'Thu',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },


        {
            field: 'ThuA',
            headerName: 'Thu (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Fri',
            headerName: 'Fri',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },

        {
            field: 'FriA',
            headerName: 'Fri (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'Sat',
            headerName: 'Sat',
            width: 70,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },
        {
            field: 'SatA',
            headerName: 'Sat (A)',
            width: 80,
            cellRenderer: (params) => (
                <Checkbox
                    checked={params.value === '1'}
                    disabled
                    size="small"
                    sx={{ padding: '2px' }}
                />
            )
        },

    ], []);

    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        floatingFilter: true,
        width: 100,
        tooltipValueGetter: (params) => params.value ?? '',
    }), []);

    useEffect(() => {
        fetchYojnaData();
        fetchShiftData();
        fetchPropertyData();
    }, []);

    const fetchYojnaData = async () => {
        try {
            const response = await getYojnaMasterdropdata({
                Flag: "",
                YojanaId: 1
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.YojanaId,
                    name: item.YojanaName,
                }));
                setYojna(dropdownItems);
            }
        } catch (error) {
            toast.error("Error fetching yojna data");
        }
    };

    const fetchShiftData = async () => {
        try {
            const response = await getShiftMasterdropdata();
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data.map((item) => ({
                    id: item.ShiftId,
                    name: item.ShiftName,
                }));
                setShiftData(dropdownItems);
                if (dropdownItems.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        Shift: dropdownItems[0].id.toString()
                    }));
                }
            }
        } catch (error) {
            toast.error("Error fetching shift data");
        }
    };

    const fetchPropertyData = async () => {
        try {
            const response = await getRoomMasterdropdata({
                Flag: "",
                UserId: UserId,
            });
            if (response?.data?.Status === 0) {
                const dropdownItems = response.data.Data?.map((item) => ({
                    id: item.PropId,
                    name: item.Name,
                }));
                setPropertyData(dropdownItems);

                if (globalProperty) {
                    setFormData(prev => ({ ...prev, Property: globalProperty.toString() }));
                } else if (dropdownItems.length > 0) {
                    setFormData(prev => ({ ...prev, Property: dropdownItems[0].id.toString() }));
                }
            }
        } catch (error) {
            toast.error("Error fetching property data");
        }
    };

    const fetchReportData = async (rowDataFromDoubleClick = null) => {
        setIsLoading(true);
        try {
            const isFromDoubleClick = rowDataFromDoubleClick !== null;
            let propId, shiftId, fromDate, toDate;

            if (isFromDoubleClick) {
                propId = parseInt(rowDataFromDoubleClick.PropId) || parseInt(location.state?.propertyId);
                shiftId = parseInt(rowDataFromDoubleClick.ShiftId) || parseInt(location.state?.shiftId);
                fromDate = rowDataFromDoubleClick.WrkRecvDt || formData.FromDate;
                toDate = rowDataFromDoubleClick.WrkRecvDt || formData.ToDate;
                console.log('Fetching details for double-click with flag: TaskRptDtDetails');
            } else {
                propId = parseInt(formData.Property);
                shiftId = parseInt(formData.Shift);
                fromDate = formData.FromDate;
                toDate = formData.ToDate;
            }
            const payload = {
                PropId: propId || parseInt(formData.Property),
                YojanaId: 1,
                ShiftId: shiftId || parseInt(formData.Shift),
                HkWrkAreaId: 1,
                StrHkTaskId: "",
                StrYojanaId: selectedYojnas.length > 0 ? selectedYojnas.join(',') : "",
                StrHkWrkAreaId: "",
                WrkRecvDt: fromDate,
                WrkRecvToDt: toDate,
                Flag: isFromDoubleClick ? "TaskRptDtDetails" : ""
            };
            if (isFromDoubleClick) {
                payload.Flag = "TaskRptDtDetails";

            } else {
                payload.Flag = ""
            }

            const response = await axiosInstance.post(
                'MstYojana/RetriveGetTrnWrkRecvTaskDtWise',
                payload
            );

            if (response.data.Status === 0 && response.data.Data?.length > 0) {

                const formattedData = response.data.Data.map((item, index) => ({
                    ...item,
                    RowNum: index + 1
                }));
                setRowData(formattedData);
            } else {
                setRowData([]);
                toast.info(response.data.Message || 'No data found for selected criteria');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching report data');
            setRowData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleYojnaMultiSelect = (event) => {
        const { value } = event.target;
        setSelectedYojnas(typeof value === 'string' ? value.split(',') : value);
    };

    const handleClearFilters = () => {
        gridRef.current?.api?.setFilterModel(null);
    };

    const onGridReady = useCallback((params) => {
        // Grid ready handler
    }, []);

    return (
        <Box
            sx={{
                width: '100%',
                height: '90vh',
                padding: '10px',
                backgroundColor: 'rgb(249, 249, 249)',
                position: 'relative'
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: "#ffffff",
                    padding: { xs: "8px 16px", sm: "12px 16px" },
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    borderRadius: "12px",
                    margin: "10px auto",
                    maxWidth: "95%",
                    flexDirection: { xs: "column", sm: "column", md: "row" },
                    gap: 2,
                }}
            >

                <Breadcrumbs
                    aria-label="breadcrumb"
                    separator="›"
                    sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        display: "flex",
                        flexDirection: { xs: "column", sm: "column", md: "row" }
                    }}
                >
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                        onClick={() => navigate('/dashboard')}
                    >
                        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                        <Box component="span">Home</Box>
                    </Link>
                    <Link
                        underline="hover"
                        color="#635bff"
                        sx={{ cursor: "pointer", fontWeight: "500" }}
                        onClick={() => navigate('/operations/housekeepin')}
                    >
                        Operation
                    </Link>
                    <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                        Daily Task Report
                    </Typography>
                </Breadcrumbs>


                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
                        justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end" },
                        width: { xs: "100%", md: "auto" }
                    }}
                >
                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "150px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Property</InputLabel>
                        <Select
                            name="Property"
                            value={formData.Property}
                            onChange={handleInputChange}
                        >
                            {propertyData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "130px", md: "130px" } }}
                        className="custom-textfield"
                    >
                        <InputLabel>Shift</InputLabel>
                        <Select
                            name="Shift"
                            value={formData.Shift}
                            onChange={handleInputChange}
                        >
                            {shiftData.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        variant="filled"
                        size="small"
                        sx={{
                            width: { xs: "100%", sm: "250px", md: "250px" },
                        }}
                        className="custom-textfield"
                    >
                        <InputLabel id="yojna-multi-label">Yojna Name</InputLabel>
                        <Select
                            labelId="yojna-multi-label"
                            multiple
                            value={selectedYojnas}
                            onChange={handleYojnaMultiSelect}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return <em>Select Yojna(s)</em>;
                                }
                                const selectedNames = selected.map(id => {
                                    const item = yojna.find(item => item.id.toString() === id.toString());
                                    return item?.name || id;
                                });

                                if (selectedNames.length > 2) {
                                    return (
                                        <Tooltip title={selectedNames.join(', ')} arrow>
                                            <span>
                                                {`${selectedNames.slice(0, 2).join(', ')} +${selectedNames.length - 2} more`}
                                            </span>
                                        </Tooltip>
                                    );
                                }

                                return selectedNames.join(', ');
                            }}
                            MenuProps={MenuProps}
                        >
                            {yojna.map((item) => (
                                <MenuItem key={item.id} value={item.id.toString()}>
                                    <Checkbox checked={selectedYojnas.indexOf(item.id.toString()) > -1} sx={{ padding: "2px" }} />
                                    <ListItemText primary={item.name} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <TextField
                        label="From Date"
                        type="date"
                        name="FromDate"
                        value={formData.FromDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            max: maxDate,
                            min: '2020-01-01'
                        }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <TextField
                        label="To Date"
                        type="date"
                        name="ToDate"
                        value={formData.ToDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                            max: maxDate,
                            min: formData.FromDate
                        }}
                        variant="filled"
                        size="small"
                        sx={{ minWidth: { xs: "100%", sm: "150px", md: "140px" } }}
                        className="custom-textfield"
                    />

                    <Button
                        variant="contained"
                        onClick={fetchReportData}
                        disabled={isLoading}
                        sx={{
                            bgcolor: '#635bff',
                            '&:hover': { bgcolor: '#5248cc' },
                            minWidth: '80px',
                            height: '38px'
                        }}
                    >
                        {isLoading ? 'Loading..' : 'Search'}
                    </Button>

                    <Tooltip title='Previous Page' arrow>
                        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
                            <IconButton
                                onClick={() => navigate('/operations/housekeepin')}
                                sx={{
                                    backgroundColor: '#635bff',
                                    borderRadius: '50%',
                                    width: 35,
                                    height: 35,
                                    '&:hover': {
                                        backgroundColor: '#635bff',
                                    },
                                    boxShadow: 3,
                                }}
                            >
                                <ArrowBackIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            </Box>

            <Box
                className="ag-theme-alpine"
                sx={{
                    height: 'calc(100% - 100px)',
                    width: '95%',
                    margin: '0 auto',
                    position: 'relative'
                }}
            >
                {isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center',
                        }}
                    >
                        <CircularProgress size="3rem" sx={{ color: '#635bff' }} />
                        <Typography sx={{ marginTop: 2, color: '#635bff', fontWeight: 'bold' }}>
                            Loading data...
                        </Typography>
                    </Box>
                ) : (
                    <AgGridReact
                        ref={gridRef}
                        rowData={rowData}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        pagination={true}
                        paginationPageSize={1000}
                        paginationPageSizeSelector={[1000, 5000, 10000]}
                        onGridReady={onGridReady}
                        enableCellTextSelection={true}
                        rowHeight={25}
                        headerHeight={35}
                        floatingFiltersHeight={30}
                        overlayNoRowsTemplate={'<span class="ag-overlay-loading-center">No data to display</span>'}
                        tooltipShowDelay={0}
                        getRowStyle={(params) => ({
                            backgroundColor: params.node.rowIndex % 2 === 0 ? '#f8f9fa' : '#ffffff'
                        })}
                    />
                )}
                {rowData.length > 0 && (
                    <Box sx={{
                        position: 'absolute',
                        bottom: 16,
                        left: 70,
                        fontSize: '14px',
                        color: 'black',
                    }}>
                        Total Records: <b>{rowData.length}</b>
                    </Box>
                )}
            </Box>

        </Box>
    );
};

export default Weektaskreport;